import { NotifyHelper } from "../../../helpers/toast";
import { eAccBienLaiThietLapActionsObj } from "../../action-types/category/IBienLaiThietLapActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const bienLaiThietLapActions = {
  ...generateActions(eAccBienLaiThietLapActionsObj, "BIEN_LAI_THIET_LAP"),
  ...generateActionForKey(
    eAccBienLaiThietLapActionsObj,
    "BIEN_LAI_THIET_LAP",
    "SAVE_SUCCESS",
    () => {
      NotifyHelper.Success("Đã cập nhật");
    }
  ),
  ...generateActionForKey(
    eAccBienLaiThietLapActionsObj,
    "BIEN_LAI_THIET_LAP",
    "SAVE_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eAccBienLaiThietLapActionsObj,
    "BIEN_LAI_THIET_LAP",
    "DELETE_SUCCESS",
    () => {
      NotifyHelper.Success("Đã xóa");
    }
  ),
  ...generateActionForKey(
    eAccBienLaiThietLapActionsObj,
    "BIEN_LAI_THIET_LAP",
    "DELETE_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
};
